import { getEventTransfer } from 'slate-react'
import isUrl from 'is-url'

const insert = (editor, type, data) => {
	editor
		.setBlocks({
			type,
			data,
		})
		.insertBlock({
			type: 'paragraph',
		})
		.focus()
}

const InsertEmbed = () => ({
	onPaste(event, editor, next) {
		const transfer = getEventTransfer(event)
		const { type, text } = transfer
		const { value } = editor

		if (type === 'text' || type === 'html') {
			if (
				isUrl(text) &&
				value.focusBlock.text.length === 0 &&
				value.focusBlock.type === 'paragraph'
			) {
				// eslint-disable-next-line
				const youtube = text.match(
					/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
				)
				const vimeo = text.match(
					/\/\/(?:www\.)?vimeo\.com\/(?:channels\/staffpicks\/)?([-\w]+)/i
				)
				const codepen = text.match(
					/^.*(codepen.io\/)([a-zA-Z0-9]+)(\/pen\/)([a-zA-Z0-9]+)/i
				) // https://github.com/thedannywahl/moodle2-codepen-textfilter/blob/master/filter.php

				if (youtube && youtube[7].length === 11) {
					// https://www.youtube.com/watch?v=AeYbX0zaJTY
					insert(editor, 'youtube', { id: youtube[7] })

					return false
				}

				if (text.indexOf('gist.github.com') !== -1) {
					// https://gist.github.com/svenadlung/eb9fead18f9f2b760cbd773ea29fb9f4
					insert(editor, 'gist', { url: text })

					return false
				}

				if (vimeo) {
					// https://vimeo.com/23311782
					insert(editor, 'vimeo', { id: vimeo[1] })

					return false
				}

				if (text.indexOf('draw.io') !== -1) {
					// https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FpIymjPcUwVS6iEZzxRrp9j%2FEmails-Newsletter%3Fnode-id%3D0%253A6293
					insert(editor, 'draw', { url: text })

					return false
				}

				if (text.indexOf('figma.com') !== -1) {
					insert(editor, 'figma', { url: text })

					return false
				}

				if (codepen) {
					// https://codepen.io/JonasBadalic/pen/PwWXqg
					insert(editor, 'codepen', {
						hash: codepen[4],
						author: codepen[2],
					})

					return false
				}
			}
		}

		return next()
	},
})

export default InsertEmbed
